import TaskCenter from '@components/LocalMerchant/TaskCenter'

export default {
  path: 'taskCenter',
  indexRoute: {
    component: TaskCenter
  },
  stat: '任务中心/首页'
}
